import { render } from "./propertybaseeditors.vue?vue&type=template&id=3dd621e0"
import script from "./propertybaseeditors.vue?vue&type=script&lang=js"
export * from "./propertybaseeditors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/propertybaseeditors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dd621e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dd621e0', __exports__)) {
    api.reload('3dd621e0', __exports__)
  }
  
  module.hot.accept("./propertybaseeditors.vue?vue&type=template&id=3dd621e0", () => {
    api.rerender('3dd621e0', render)
  })

}


export default __exports__